import { Injectable } from '@angular/core';
// import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Usuario } from '../models/Usuario';
import 'rxjs/add/operator/map'
import { environment } from '../../environments/environment';
import { ServersService } from './servers.service';
import { HttpCacheService } from './httpcache.service';

@Injectable()
export class EmpresaService {
    constructor(private http: HttpCacheService, private servers: ServersService) { }

    getAll(callback: any) {

        return this.http.get(0, this.servers.serverName + '/empresa', callback);
    }

    save(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/empresa', object, callback);
    }
    update(object: any, callback: any) {
        return this.http.put(30, this.servers.serverName + '/empresa/'+object.id, object, callback);
    }

    updateState(object: any, callback: any) {
        var url = this.servers.serverName + '/empresa/update/state/' + object.id;
        return this.http.put(0,url,object, callback);
    }
}



// WEBPACK FOOTER //
// ./src/app/servicios/empresa.service.ts